import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { FaDiscord } from "react-icons/fa";
import { PlayArrow, ArrowForward } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

function HeroSection() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        pt: { xs: 16, md: 20 },
        pb: { xs: 10, md: 15 },
        px: { xs: 2, sm: 3, lg: 4 },
        textAlign: "center",
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ maxWidth: "4xl", mx: "auto" }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "2.5rem", md: "4rem", lg: "5rem" },
              fontWeight: "bold",
              color: theme.palette.text.primary,
              mb: 3,
              lineHeight: 1.1,
            }}
          >
            Your{" "}
            <Box
              component="span"
              sx={{
                background: theme.palette.brand.gradientText,
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                color: "transparent",
                WebkitTextFillColor: "transparent",
              }}
            >
              SMART
            </Box>{" "}
            Home Agent
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontSize: { xs: "1.1rem", md: "1.5rem" },
              color: theme.palette.text.secondary,
              mb: 4,
              lineHeight: 1.6,
              maxWidth: "800px",
              mx: "auto",
            }}
          >
            AI-driven smart home agent. Effortlessly craft powerful automations
            from simple language instructions.
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              justifyContent: "center",
              alignItems: "center",
              mb: 8,
            }}
          >
            <Button
              variant="contained"
              size="large"
              href="https://app.mhome.ai"
              sx={{
                background: theme.palette.brand.gradient,
                backgroundSize: "200% 200%",
                animation: "gradient 3s ease infinite",
                "@keyframes gradient": {
                  "0%": { backgroundPosition: "0% 50%" },
                  "50%": { backgroundPosition: "100% 50%" },
                  "100%": { backgroundPosition: "0% 50%" },
                },
                color: theme.palette.text.white,
                fontSize: "1.1rem",
                px: 4,
                py: 1.5,
                textTransform: "none",
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: theme.shadows[8],
                },
              }}
              endIcon={<ArrowForward />}
            >
              Start Now (Beta)
            </Button>

            <Button
              variant="outlined"
              size="large"
              component="a"
              href="https://discord.gg/mspCBJp4E7"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: theme.palette.text.primary,
                borderColor: theme.palette.border.strong,
                fontSize: "1.1rem",
                px: 4,
                py: 1.5,
                textTransform: "none",
                "&:hover": {
                  borderColor: "#5865F2",
                  backgroundColor: "rgba(88, 101, 242, 0.1)",
                  color: "#5865F2",
                },
              }}
              startIcon={<FaDiscord />}
            >
              Join Discord
            </Button>
          </Box>
        </Box>

        {/* Demo/Preview Section */}
        <Box sx={{ mt: 10, position: "relative" }}>
          <Box
            sx={{
              borderRadius: 4,
              p: 0,
              backdropFilter: "blur(10px)",
              border: `1px solid ${theme.palette.border.light}`,
            }}
          >
            <Box
              sx={{
                aspectRatio: "16/9",
                background:
                  "linear-gradient(135deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.1))",
                borderRadius: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box sx={{ textAlign: "center" }}>
                <Box
                  sx={{
                    width: 64,
                    height: 64,
                    background: theme.palette.brand.gradient,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mx: "auto",
                    mb: 2,
                  }}
                >
                  <PlayArrow
                    sx={{
                      fontSize: 32,
                      color: theme.palette.text.primary,
                      ml: 0.5,
                    }}
                  />
                </Box>
                <Typography sx={{ color: theme.palette.text.quaternary }}>
                  Interactive Platform Demo
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default HeroSection;
